// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '/static/qmsj/css/table.css'

import 'vue-croppa/dist/vue-croppa.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import Croppa from 'vue-croppa'
import '../static/qmsj/css/font-awesome.min.css'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(Croppa)
Vue.use(ElementUI);
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
import Print from '@/util/printjs/Print'
Vue.use(Print);
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

router.beforeEach((to,from,next) => {
    if(to.matched.some( m => m.meta.auth)){
// 对路由进行验证
        if($.cookie("token") == null || $.cookie("token") == undefined || $.cookie('token') == 'null') {
            next({path:'/login'})
            // location.href="https://saas.gymbaby.cn";
        }else{
            //验证长时间未操作过期 或者 重复登录帐号
            var token = $.cookie('token')
            $.ajax({
                'type':'post',
                'url':process.env.apiUrl + 'saas/comm/check_login',
                'data':{
                    token:token
                },
                success:function (e) {
                    if(e.status == 10001){
                        next()
                    }else if(e.status == 10003 || e.status == 10004 || e.status == 10006){
                        alert(e.msg);
                        $.cookie("token",null)
                        next({path:'/login'})
                        // location.href="https://saas.gymbaby.cn";
                    }else{
                        next()
                    }
                }
            })
            next()
        }
    }else{
        next()
    }
})
Vue.prototype.$http = {
    get(url, params={}, noCloseLoading) {
        if ( url != process.env.apiUrl + "/point/point_rule/search") {
            loadingInstance = ElementUI.Loading.service({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        }
        if (!params.token || params.token == '') {
            params.token = $cookies.get("token")
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: "get",
                data: params,
                complete() {
                    if (!noCloseLoading && url != process.env.apiUrl + "/point/point_rule/search") {
                        loadingInstance.close();
                    }
                },
                success(res) {
                    resolve(res)
                },
                fail(err) {
                    reject(err);
                }
            });
        })
    },
    post(url, params={}, noCloseLoading) {
        let loadingInstance
        if ( url != process.env.apiUrl + "/point/point_rule/search") {
            loadingInstance = ElementUI.Loading.service({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        }
        if (!params.token || params.token == '') {
            params.token = $cookies.get("token")
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: "post",
                data: params,
                complete() {
                    if ( !noCloseLoading && url != process.env.apiUrl + "/point/point_rule/search") {
                        loadingInstance.close();
                    }
                },
                success(res) {
                    resolve(res)
                },
                fail(err) {
                    reject(err);
                },
            });
        })
    }
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js